import {
  FETCH_SKILLS_REQUEST,
  SAVE_SKILL_REQUEST,
  DELETE_SKILL_REQUEST,
  GET_EMPLOYEE_SKILLS_REQUEST,
  SAVE_EMPLOYEE_SKILLS_REQUEST,
} from "./actionTypes";

/* Fetch Skill Master */
export const fetchSkills = (unitId) => ({
  type: FETCH_SKILLS_REQUEST,
  payload:{unitId}
});

/* Create / Update Skill */
export const saveSkill = (data) => ({
  type: SAVE_SKILL_REQUEST,
  payload: data,
});

/* Delete Skill */
export const deleteSkill = (payload) => ({
  type: DELETE_SKILL_REQUEST,
  payload,
});


export const getEmployeeSkills = (payload) => ({
  type: GET_EMPLOYEE_SKILLS_REQUEST,
  payload, // { employee_id }
});

/* Save employee skills */
export const saveEmployeeSkills = (payload) => ({
  type: SAVE_EMPLOYEE_SKILLS_REQUEST,
  payload, // { employee_id, skills: [] }
});